<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      destroy-on-close
      title="有权应收款设置"
      :visible.sync="dialogShow"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" label-width="150px">
          <el-table :data="receivablesData" border>
            <el-table-column width="200" label="指标" property="target"></el-table-column>
            <el-table-column width="150" label="项目状态" property="status" />
            <el-table-column property="paymentMethod" label="甲方合同付款方式" width="130" />
            <el-table-column property="desc" label="计算规则">
              <template slot-scope="scope" v-if="scope.row.desc">
                <div v-for="(item, index) in scope.row.desc.split('\n\n')" :key="index">
                  {{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="配置规则" width="400">
              <template slot-scope="scope">
                <el-form-item v-for="item in scope.row.sub_data_switch_config_detail" :key="item.valid_type" :label="item.valid_names" :prop="item.valid_type">
                  <el-select v-model="item.valid_ids" placeholder="请选择">
                    <el-option v-for="item in dimensionOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  data() {
    return {
      drawerSize: '70%',
      dialogShow: false,
      tenantId: '-1',
      loading: false,
      showPerson: false,
      noticeTimeShow: false,
      dimensionOptions: [],
      receivablesData: []
    }
  },
  methods: {
    // 根据租户获取应收账款配置
    getReceivableCalculation() {
      let that = this
      that.dialogShow = true
      that.$http.get('${portal}/portal/data_switch_config/getReceivableCalculationEnums').then((resp) => {
        if (resp && resp.data) {
          that.$nextTick(() => {
            that.dimensionOptions = utils.findDictList('sgskjd2', that.allDataDict)
            resp.data.forEach((item) => {
              item.sub_data_switch_config_detail.forEach((items) => {
                !items['valid_ids'] && (items['valid_ids'] = that.dimensionOptions[0].key)
              })
            })
            that.receivablesData = resp.data
          })
        }
      })
    },
    chooseCustom(name) {
      this.chooseName = name
    },
    //设置提醒时间
    showNoticeTime() {
      this.noticeTimeShow = true
    },
    closeNoticeTime(val) {
      if (val) {
        this.form.remind_time = val
      }
      this.noticeTimeShow = false
    },
    //变量选择
    setField(val, name) {
      let str = `{${val.label}:${val.value}}`
      this.form[name] = this.form[name].slice(0, this.blurIndex) + str + this.form[name].slice(this.blurIndex)
    },
    //重置必填项
    resetFields() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    //统计数据
    statisticsDataChange() {},
    //关闭表单
    handleClose() {
      this.dialogShow = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      console.log(this.receivablesData, 5555)
      this.loading = true
      this.$http
        .post('${portal}/portal/data_switch_config/saveReceivableCalculation', this.receivablesData)
        .then((res) => {
          if (res.data.state) {
            this.loading = false
            this.$message.info('保存成功！')
          } else {
            this.loading = false
            this.$message.error('保存失败！')
          }
          this.handleClose()
        })
        .catch(() => {
          this.loading = false
        })
    },
    //设置提醒人
    setPerson() {
      this.showPerson = true
    },
    //设置提醒人关闭
    close() {
      this.showPerson = false
    },
    onConfirm(val, sonTable, str) {
      this.form.reminder_members = str
      this.form.sub_business_reminder_member = sonTable
      this.showPerson = false
    }
  }
}
</script>

<style scoped></style>
